import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  async connect(): Promise<void> {
    const element = this.element as HTMLElement;
    element.classList.add(this.checkTouch() ? 'touch' : 'no-touch');
  }

  private checkTouch(): boolean {
    return window.ontouchstart !== undefined;
  }
}
